module.exports = __webpack_public_path__ + "static/img/sw3.0ea866c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/sw3.png
// module id = 8BMV
// module chunks = 37